export default "/react/period-2744e61a.png";